import React from 'react';
import Styles from './Modal.css';
import clsx from 'clsx';
import Button from '../Button/Button';

function Modal({ children, variant = 'side-panel', open = false, setOpen, contentFill = false }) {
  const closeModal = () => {
    if (!setOpen) return;
    setOpen(false);
  };

  return (
    <>
      <div
        className={clsx({
          'modal-widget': true,
          [variant]: true,
          open: open,
          'content-fill': contentFill,
        })}
      >
        <span className="overlay" />
        <div className="frame">
          <div className="content">
            <Button variant="flat" className="modal-widget-close" onClick={closeModal}>
              <img alt="" src="assets/simulador-energia-solar/jornada/ic-close-side-modal.svg" />
            </Button>

            {children}
          </div>
        </div>
      </div>
      <style jsx>{Styles}</style>
    </>
  );
}

export default Modal;
